angular.module('zc.projects')

.directive 'campaignCreatives', (Campaign) ->
  restrict: 'E'
  scope: {
    campaign: '='
  }
  templateUrl: '/templates/projects.campaigns/views/directives/campaign_creatives.html'

  link: (scope, element, attrs) ->
    Campaign.getTemplate
      projectId: scope.campaign.project_id
      campaignId: scope.campaign.id
    .then (template) ->
      scope.template = template



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/directives/campaign_creatives.coffee